import Sortable from 'js/vendor/sortable.min'
import { openCloudinaryWidget } from 'js/lib/cloudinary'

$(document).ready(function () {
  if ($('#listing_photo_upload').length) {
    document.getElementById('listing_photo_upload').addEventListener( 'click',
      async function () {
        var results = await openCloudinaryWidget({
          thumbnailTransformation: { width: 80, height: 80, crop: 'fill' },
          maxImageWidth: 2000,
          maxImageHeight: 2000,
          tags: ['listing_photo'],
        })
        results.forEach( function(result) {
          uploadAndDisplay(result.info)
        })
      },
      false
    )

    function uploadAndDisplay(photo) {
      var formData = new FormData()
      var url = photo.secure_url.split('upload/')
      var squaredUrl = url.join('upload/fl_lossy/')

      formData.append('secure_url', photo.secure_url)
      formData.append('public_id', photo.public_id)
      formData.append('resource_type', photo.resource_type)
      formData.append('order', $('.photo').length)

      $.ajax({
        url: 'listing_photos',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (photoResults) {
          if (photo.resource_type === 'image') {
            const image = $('<img />', {
              src: url.join('upload/h_90,w_90,c_fill,g_face,f_auto,q_auto:eco/'),
              alt: 'listing photo',
            })

            $('#sortable').append(
              $('<li>', {
                class: 'photo',
                id: photo.public_id,
                data: {
                  photo: {
                    id: photoResults.id,
                    transformation: '',
                    original_image_path: url,
                  },
                },
              })
            )

            $('#' + photo.public_id).append(image)
            $('<a />', {
              class: 'action edit-photo',
              text: 'Edit',
              href: '',
              rel: 'nofollow',
              'data-action': 'open-modal',
              'data-modal': 'edit_modal',
              'data-url-path': squaredUrl,
            }).appendTo('#' + photo.public_id)

            $('<a />', {
              class: 'action remove-photo',
              text: 'Remove',
              href: 'listing_photos/' + photoResults.id,
              rel: 'nofollow',
              'data-method': 'delete',
              'data-confirm': 'Are you sure you want to delete this photo?',
            }).appendTo('#' + photo.public_id)
          }
          if (photo.resource_type === 'video') {
            let videoImage = url.join('upload/w_90,h_90,c_fill/')
            videoImage = videoImage.replace(/\.[^/.]+$/, '')
            const image = $('<img />', {
              src: videoImage + '.jpg',
              alt: 'listing photo',
            })

            $('#photos').append('<li class="video pet-listing__videos__thumbnail" id="' + photo.public_id + '"></li>')
            $('#' + photo.public_id).append('<div class="overlay video_uploader"></div>')
            $('#' + photo.public_id).append(image)

            $('<a />', {
              class: 'action remove-photo',
              text: 'Remove',
              href: 'listing_photos/' + photoResults.id,
              rel: 'nofollow',
              'data-method': 'delete',
              'data-confirm': 'Are you sure you want to delete this video?',
            }).appendTo('#' + photo.public_id)
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload()
          }
        },
      })
    }

    $(document.body).on('click', '.photo img', function () {
      $(this).parent().find('.edit-photo').click()
    })

    //edit image
    $(document.body).on('click', '.edit-photo', function () {
      $('#croppie_container').empty()
      var imgTag = $(this).parent().find('img')
      var imageData = $(this).parent().data('photo') ? $(this).parent().data('photo') : []
      var url = $(this).data('url-path')
      var el = document.getElementById('croppie_container')
      var rotate = imageData.transformation ? imageData.transformation.a : 0
      var boundary = $(window).width() < 484 ? $(window).width() - 100 : 400
      var points = []
      var p

      var crop = new Croppie(el, {
        viewport: { width: 247, height: 247 },
        boundary: { width: boundary, height: boundary },
        showZoomer: true,
        enableOrientation: true,
      })

      if (imageData.transformation && imageData.transformation.w === 400) {
        points = [
          imageData.transformation.x * 1.595,
          imageData.transformation.y * 1.595,
          imageData.transformation.x2 * 1.595,
          imageData.transformation.y2 * 1.595,
        ]
      } else if (imageData.transformation) {
        points = [
          imageData.transformation.x,
          imageData.transformation.y,
          imageData.transformation.x2,
          imageData.transformation.y2,
        ]
      }

      if (imageData.transformation) {
        let imageOrientation = 1
        if (imageData.transformation.a === 90) {
          imageOrientation = 6
        } else if (imageData.transformation.a === 180) {
          imageOrientation = 3
        } else if (imageData.transformation.a === 270) {
          imageOrientation = 8
        }

        p = crop.bind({
          url: url,
          points: points,
          zoom: imageData.transformation ? imageData.transformation.z : 1,
          orientation: imageOrientation,
        })
      } else {
        p = crop.bind({
          url: url,
          points: points,
          zoom: imageData.transformation ? imageData.transformation.z : 1,
          enableExif: true,
        })
      }

      p.then(function () {
        $('.loader').hide()
      })

      $('.cr-slider-wrap').append('<p>Zoom <i class="fa fa-search-plus" aria-hidden="true"></i></p>')

      $('.rotate').click(function () {
        crop.rotate(90)
        rotate = rotate != 360 ? rotate + 90 : (rotate = 90)
      })

      $('.edit_modal .save')
        .unbind()
        .click(function () {
          crop.result('html').then(function (data) {
            $('.edit_result').append(data)
            var d = crop.get()

            setTimeout(function () {
              var l =
                $('.edit_result img').height() > $('.edit_result img').width()
                  ? $('.edit_result img').height()
                  : $('.edit_result img').width()
              var x = d.points[0]
              var y = d.points[1]
              var x2 = d.points[2]
              var y2 = d.points[3]
              var a = rotate
              var z = d.zoom

              if (!$('.edit_result img').height() || !$('.edit_result img').width()) {
                $('#croppie_container p').empty()
                $('#croppie_container').append('<p class="error">Error occured while saving.</p>')
              }

              $.ajax({
                url: 'listing_photos/' + imageData.id,
                type: 'PUT',
                data: { transformation: JSON.stringify({ x, y, a, w: l, h: l, z, x2, y2 }) },
                success: function (result) {
                  imgTag.attr('src', result[1])
                  imageData.transformation = { x, y, a, w: l, h: l, z, x2, y2 }
                  imgTag.closest('.photo').attr('data-photo', JSON.stringify(imageData))
                  $('.edit_modal .modal-wrapper__close').click()
                  $('.edit_result').empty()
                  $('.loader').show()
                },
                error: function () {
                  $('#croppie_container p').empty()
                  $('#croppie_container').append('<p class="error">Error occured while saving.</p>')
                },
              })
            }, 1000)
          })
        })
    })

    var el = document.getElementById('sortable')
    if (el) {
      Sortable.create(el, {
        scroll: false,
        onUpdate: function () {
          var arr = Array()
          $('#sortable li').each(function () {
            const dataPhoto = $(this).data('photo')
            arr.push(dataPhoto.id)
          })
          $.ajax({ url: 'order_images', type: 'PUT', data: { order: arr } })
        },
      })
    }
  }
})
